module.exports = __webpack_public_path__ + "img/bg-top@xs.714a15d2.jpg";